import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ConfirmationService, LazyLoadEvent, MessageService } from 'primeng/api';
import { AuthService } from 'src/app/auth/auth.service';
import { QmAutocompleteData } from 'src/uikit/qm-autocomplete/qm-autocomplete-data';
import { ChatUserData } from 'src/uikit/qm-chat/chat-user.interface';
import { QmCheckboxData } from 'src/uikit/qm-checkbox-group/qm-checkbox-data';
import { QmListboxData } from 'src/uikit/qm-listbox/qm-listbox-data';
import { QmMultiselectData } from 'src/uikit/qm-multiselect/qm-multiselect-data';
import { QmOrderlistData } from 'src/uikit/qm-orderlist/qm-orderlist-data';
import { QmPicklistData } from 'src/uikit/qm-picklist/qm-picklist-data';
import { QmRadiobuttonData } from 'src/uikit/qm-radiobutton-group/qm-radiobutton-data';
import { QmSelectData } from 'src/uikit/qm-select/qm-select-data';
import { QMTableData } from 'src/uikit/qm-table/qm-table-data.interface';
import { QMTableOptions } from 'src/uikit/qm-table/qm-table-options.interface';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css'],
  providers: [ConfirmationService, MessageService]
})
export class HomeComponent implements OnInit {

  data: QmListboxData[];
  data2: QmMultiselectData[];
  listaPessoas!: QmSelectData[];
  listaOptions!: QmRadiobuttonData[];
  listaCheckOptions!: QmCheckboxData[];
  listaAutoComplete!: QmAutocompleteData[];
  listaSuggestions: QmAutocompleteData[] = [];
  claims: any;

  tableData!: QMTableData<any>;
  tableData2!: QMTableData<any>;
  tableOptions! : QMTableOptions;

  formInput1!: ModelFormGroup<FormInput1>;
  formInput2!: ModelFormGroup<FormInput2>;
  formInput3!: ModelFormGroup<FormInput3>;
  formInput4!: ModelFormGroup<FormInput4>;
  formInput5!: ModelFormGroup<FormInput5>;
  formInput6!: ModelFormGroup<FormInput6>;
  formInputEditor!: ModelFormGroup<FormInputEditor>;

  sourceList!:  QmPicklistData[];
  targetList:  QmPicklistData[] = [];
  sourceOrderList!: QmOrderlistData[];

  myText: string = "";
  showDialog: boolean = false;

  access_token!: string;
  refresh_token!: string;
  id_token!: string;

  messageUser: ChatUserData = {
    username: "Chat GPT",
    avatar: "/assets/img/chat-gpt.png",
    online: true
  }

  constructor(private confirmService: ConfirmationService,
              private authService: AuthService,
              private messageService: MessageService) {
    
    
    /*for (const key in this.authService.claims){
      const data = this.authService.claims[key];
      console.log('Chave: ' + key + ' Valor: ' + data);
    }*/
    this.data = [
      {name: "Diego", value: "DIEGO", disabled: false},
      {name: "Pablo", value: "PABLO", disabled: true},
      {name: "Emmanuel", value: "EMMANUEL", disabled: true},
      {name: "Rafael", value: "RAFAEL", disabled: false}
    ]

    this.data2 = [
      {name: "Diego", value: "DIEGO", disabled: false},
      {name: "Pablo", value: "PABLO", disabled: true},
      {name: "Emmanuel", value: "EMMANUEL", disabled: true},
      {name: "Rafael", value: "RAFAEL", disabled: false}
    ]

    this.sourceList = [
      {label: "Diego", value: "VALOR1"},
      {label: "Diego2", value: "VALOR2"},
      {label: "Diego3", value: "VALOR3"},
      {label: "Diego4", value: "VALOR4"},
      {label: "Diego5", value: "VALOR5"},
      {label: "Diego6", value: "VALOR6"},
      {label: "Diego7", value: "VALOR7"},
      {label: "Diego8", value: "VALOR8"}
    ];

    this.sourceOrderList = [
      {label: "Diego", value: "VALOR1"},
      {label: "Diego2", value: "VALOR2"},
      {label: "Diego3", value: "VALOR3"},
      {label: "Diego4", value: "VALOR4"},
      {label: "Diego5", value: "VALOR5"},
      {label: "Diego6", value: "VALOR6"},
      {label: "Diego7", value: "VALOR7"},
      {label: "Diego8", value: "VALOR8"}
    ];

  }

  ngOnInit(): void {

    this.formInput1 =  new FormGroup({
      name: new FormControl('', {nonNullable: true, validators: [Validators.required]}),
      accessKey: new FormControl('', {nonNullable: true,  validators: [Validators.required]}),
      userAge: new FormControl(0, {nonNullable: true,  validators: [Validators.required]})
    });

    this.formInput2 =  new FormGroup({
      longText: new FormControl('', {nonNullable: true, validators: [Validators.required]}),
      cpfValue: new FormControl('', {nonNullable: true,  validators: [Validators.required]}),
      cnpjValue: new FormControl('', {nonNullable: true,  validators: [Validators.required]}),
      telValue: new FormControl('', {nonNullable: true,  validators: [Validators.required]}),
    });

    this.formInput3 =  new FormGroup({
      optionSelected: new FormControl([] as string[], {nonNullable: true}),
      optionSelected2: new FormControl('', {nonNullable: true}),
    });

    this.formInput4 =  new FormGroup({
      roles: new FormControl([] as string[], {nonNullable: true, validators: [Validators.required]}),
      selectValue: new FormControl('', {nonNullable: true, validators: [Validators.required]}),
      ACFValue: new FormControl('', {nonNullable: true, validators: [Validators.required]}),
    });

    this.formInput5 =  new FormGroup({
      valueListBox: new FormControl('', {nonNullable: true, validators: [Validators.required]}),
      valueMultiSelect: new FormControl([] as string[], {nonNullable: true, validators: [Validators.required]}),
      valueCalendar: new FormControl<Date>(new Date(), {nonNullable: true, validators: [Validators.required]}),
    });

    this.formInput6 =  new FormGroup({
      valueToggleButton: new FormControl(false, {nonNullable: true, validators: [Validators.required]}),
      valueInputSwitch: new FormControl(false, {nonNullable: true, validators: [Validators.required]}),
      valueSlider: new FormControl(0, {nonNullable: true, validators: [Validators.required]}),
      valueColor: new FormControl('', {nonNullable: true, validators: [Validators.required]}),
    });

    this.formInputEditor =  new FormGroup({
      valueTextEditor: new FormControl('', {nonNullable: true, validators: [Validators.required]}),
    });


    this.listaPessoas = [
      {label: "Diego", value : 1},
      {label: "Rafael", value: 2 },
      {label: "Pablo", value: 3 },
      {label: "Emmanuel", value: 4},
    ]

    this.listaOptions = [
      {name: "Mussarela", key : "val1", value: "MUSSARELA"},
      {name: "Bacon", key: "val2", value: "BACON" },
      {name: "Calabresa", key: "val3", value: "CALABRESA" },
      {name: "Portuguesa", key: "val4", value: "PORTUGUESA"},
    ]

    this.listaCheckOptions = [
      {name: "Em andamento", key : "val5", value: "EM_ANDAMENTO"},
      {name: "Em aprovação", key: "val6", value: "EM_APROVACAO" },
      {name: "Disponível", key: "val7", value: "DISPONIVEL" }
    ]

    this.listaAutoComplete = [
        {label: "Argentina", value: "ARGENTINA"},
        {label: "Brasil", value: "BRASIL"},
        {label: "Chile",  value: "CHILE"},
        {label: "Peru",  value: "PERU"},
        {label: "Bolívia",  value: "BOLIVIA"},
        {label: "Venezuela",  value: "VENEZUELA"},
        {label: "Equador",  value: "EQUADOR"},
        {label: "Uruguai", value: "URUGUAI"}
    ];


    this.tableData = {
      columns: [
        { title: "Nome", field: "name", type: 'text', globalFilter: true},
        { title: "Descrição", field: "description", type: 'text', localFilter: false},
        { title: "Missão", field: "mission", type: 'text', sortable: false},
        { title: "Valores", field: "values", type: 'text', sortable: false},
        { title: "Revisão", field: "revision", type: 'numeric', localFilter: true},
        { title: "Criado em", field: "createdat", type: 'date', localFilter: true, sortable: false}
      ],
      values: [
        {name: "Processo A", description: "Descrição Processo A", mission: "Missão Processo A", values: "Valores Processo A", revision: 1, createdat: new Date() },
        {name: "Processo B", description: "Descrição Processo B", mission: "Missão Processo B", values: "Valores Processo B", revision: 1,  createdat: new Date() },
        {name: "Processo C", description: "Descrição Processo C", mission: "Missão Processo C", values: "Valores Processo C", revision: 1,  createdat: new Date() },
        {name: "Processo D", description: "Descrição Processo D", mission: "Missão Processo D", values: "Valores Processo D", revision: 1,  createdat: new Date() }
      ]

    }

    this.tableData2 = {
      columns: [
        { title: "Nome", field: "name", type: 'text', globalFilter: true},
        { title: "Descrição", field: "description", type: 'text', localFilter: false},
        { title: "Missão", field: "mission", type: 'text', sortable: false},
        { title: "Valores", field: "values", type: 'text', sortable: false},
        { title: "Revisão", field: "revision", type: 'numeric', localFilter: true},
        { title: "Criado em", field: "createdat", type: 'date', localFilter: true, sortable: false}
      ],
      values: []
    }


    this.tableOptions = {tableTitle: "Processos", hasHeader: true, hasTitle: false, hasPaginator: true, hasPageReport: true}
    this.updateTokens();

  }

  public lazyLoadTableData (event: LazyLoadEvent) {
    var values = [
      {name: "Processo Lazy A", description: "Descrição Processo", mission: "Missão Processo", values: "Valores Processo", revision: 1, createdat: new Date() },
      {name: "Processo Lazy B", description: "Descrição Processo", mission: "Missão Processo", values: "Valores Processo", revision: 1,  createdat: new Date() },
      {name: "Processo Lazy C", description: "Descrição Processo", mission: "Missão Processo", values: "Valores Processo", revision: 1,  createdat: new Date() },
      {name: "Processo Lazy D", description: "Descrição Processo", mission: "Missão Processo", values: "Valores Processo", revision: 1,  createdat: new Date() },
      {name: "Processo Lazy E", description: "Descrição Processo", mission: "Missão Processo", values: "Valores Processo", revision: 1,  createdat: new Date() },
      {name: "Processo Lazy F", description: "Descrição Processo", mission: "Missão Processo", values: "Valores Processo", revision: 1,  createdat: new Date() },
      {name: "Processo Lazy G", description: "Descrição Processo", mission: "Missão Processo", values: "Valores Processo", revision: 1,  createdat: new Date() },
      {name: "Processo Lazy H", description: "Descrição Processo", mission: "Missão Processo", values: "Valores Processo", revision: 1,  createdat: new Date() },
      {name: "Processo Lazy I", description: "Descrição Processo", mission: "Missão Processo", values: "Valores Processo", revision: 1,  createdat: new Date() },
      {name: "Processo Lazy J", description: "Descrição Processo", mission: "Missão Processo", values: "Valores Processo", revision: 1,  createdat: new Date() }
    ]
    this.tableData2.values = values.slice(event.first!, event.first! + event.rows!)
  }

  private updateTokens() {
    this.access_token = this.authService.accessToken;
    this.refresh_token = this.authService.refreshToken;
    this.id_token = this.authService.idToken;
  }

    onChangeValue(event: any) {
      console.log(event);
    }

    showDialogEvent() {
      this.showDialog = true;
    }

    hideDialogEvent() {
      this.showDialog = false;
    }

  onSearchData(event: any): void {
    this.listaSuggestions = this.listaAutoComplete.filter(el => el.label?.trim().toLowerCase().indexOf(event.query?.trim().toLowerCase()) !== -1);
    }

  confirm() {
    this.confirmService.confirm({
      key: 'qm-dialog',
      message: "Deseja sair? Informações que não foram salvas serão perdidas",
      accept: () => {
        console.log('Você aceitou');
      },
      reject: () => {
        console.log('Você rejeitou');
      }
    })
  }

  confirmPopup(event: Event) {
    this.confirmService.confirm({
      key: 'qm-popup',
      target: event.target as EventTarget,
      icon: 'pi pi-exclamation-triangle',
      message: "Deseja apagar os registros? Esta operação é irreversível",
      accept: () => {
        console.log('Você aceitou');
      },
      reject: () => {
        console.log('Você rejeitou');
      }
    })
  }

  confirmSucesso() {
    this.messageService.add({severity:'success', summary:'Service Message', detail:'Via MessageService', sticky: true});
  }

  confirmInfo() {
    this.messageService.add({severity:'info', summary:'Service Message', detail:'Via MessageService', sticky: true});
  }

  confirmAviso() {
    this.messageService.add({severity:'warn', summary:'Service Message', detail:'Via MessageService', sticky: true});
  }

  confirmFalha() {
    this.messageService.add({severity:'error', summary:'Service Message', detail:'Via MessageService', sticky: true});
  }

  get f1() {
    return this.formInput1.controls;
  }

  get f2() {
    return this.formInput2.controls;
  }

  get f3() {
    return this.formInput3.controls;
  }

  get f4() {
    return this.formInput4.controls;
  }

  get f5() {
    return this.formInput5.controls;
  }

  get f6() {
    return this.formInput6.controls;
  }


  messageSentHandler(event: any) {
    console.log(event);
 }


}

type ModelFormGroup<T> = FormGroup<{
  [K in keyof T]: FormControl<T[K]>;
}>;

type FormInput1 = {
  name: string;
  accessKey: string;
  userAge: number;
}

type FormInput2 = {
  longText: string;
  cpfValue: string;
  cnpjValue: string;
  telValue: string;
}

type FormInput3 = {
  optionSelected: string[];
  optionSelected2: string;
}

type FormInput4 = {
  roles: string[];
  selectValue: string;
  ACFValue: string;
}

type FormInput5 = {
  valueListBox: string;
  valueMultiSelect: string[]
  valueCalendar: Date;
}

type FormInput6 = {
  valueToggleButton: boolean;
  valueInputSwitch: boolean;
  valueSlider: number;
  valueColor: string;
}

type FormInputEditor = {
  valueTextEditor: string;
}




